export default "__VITE_ASSET___roq$wdV__"